import React from "react";

import ScanQRForm from "../../components/Scout/ScanQRForm";

const ScanScoutQR = () => {
  return <ScanQRForm />;
};

export default ScanScoutQR;

